const cards = [
  {
    id: 1,
    title: '动作大片 · 肾上腺素飙升',
    desc: '精选好莱坞与国产动作巨制，高清不缓冲带来极致观影体验，电影在线观看首选。',
    tag: '电影在线观看',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20movie%20scene%20with%20dramatic%20explosion%20silhouette%20and%20warm%20golden%20light%2C%20cinematic%20composition%20with%20motion%20blur%20effect%2C%20professional%20film%20poster%20aesthetic%2C%20intense%20atmosphere%20with%20rich%20amber%20and%20dark%20contrast&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '温情喜剧 · 笑到停不下来',
    desc: '轻松欢快的喜剧电影与电视剧免费观看，适合全家一起享受的欢乐时光。',
    tag: '电视剧免费',
    img: 'https://readdy.ai/api/search-image?query=Bright%20cheerful%20comedy%20scene%20with%20warm%20sunlight%20streaming%20through%20window%2C%20cozy%20living%20room%20atmosphere%2C%20lighthearted%20cinematic%20aesthetic%2C%20soft%20pastel%20warm%20tones%2C%20happy%20family%20entertainment%20vibe&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '悬疑推理 · 烧脑不断',
    desc: '精挑细选的高分悬疑推理影视视频，每一部都让你欲罢不能猜不到结局。',
    tag: '影视视频',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20office%20with%20dramatic%20shadow%20and%20warm%20desk%20lamp%20lighting%2C%20evidence%20board%20with%20red%20strings%2C%20noir%20cinematic%20atmosphere%2C%20suspenseful%20film%20aesthetic%2C%20rich%20dark%20brown%20and%20amber%20tones&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '浪漫爱情 · 心动瞬间',
    desc: '最动人的爱情故事电影在线观看，从青涩初恋到永恒之爱，感动每一刻。',
    tag: '电影在线观看',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20sunset%20scene%20with%20soft%20golden%20hour%20lighting%2C%20cinematic%20couple%20silhouette%2C%20dreamy%20bokeh%20background%2C%20warm%20tender%20atmosphere%2C%20elegant%20film%20poster%20composition%20with%20rose%20gold%20tones&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '科幻奇幻 · 想象无限',
    desc: '震撼视觉的科幻大片与奇幻冒险，最新影视特效带来前所未有的观影震撼。',
    tag: '最新影视',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20scifi%20landscape%20with%20floating%20digital%20holograms%20and%20warm%20neon%20light%20trails%2C%20abstract%20technology%20particles%2C%20cinematic%20space%20atmosphere%2C%20elegant%20dark%20blue%20and%20gold%20contrast%2C%20professional%20visual%20effects%20style&width=800&height=500&seq=card-05&orientation=landscape',
  },
  {
    id: 6,
    title: '经典老片 · 永恒回响',
    desc: '那些年感动过我们的经典电影，高清修复画质重温光影岁月中的不朽传奇。',
    tag: '91电影视频',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20film%20projector%20in%20dark%20room%20casting%20warm%20golden%20beam%20of%20light%2C%20old%20film%20reels%20on%20wooden%20table%2C%20nostalgic%20cinema%20atmosphere%2C%20classic%20movie%20aesthetic%2C%20rich%20sepia%20and%20warm%20brown%20tones&width=800&height=500&seq=card-06&orientation=landscape',
  },
  {
    id: 7,
    title: '综艺精选 · 欢乐无限',
    desc: '最火爆综艺节目高清合集，搞笑名场面、感动瞬间一网打尽，综艺迷必看。',
    tag: '综艺节目',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20variety%20show%20stage%20with%20colorful%20confetti%20and%20dynamic%20spotlight%20effects%2C%20energetic%20entertainment%20atmosphere%2C%20professional%20television%20production%20scene%2C%20bright%20cheerful%20warm%20lighting%2C%20modern%20broadcast%20aesthetic&width=800&height=500&seq=card-07&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              影视推荐
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              精心挑选的影视内容，总有一部适合你
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cards.map((card) => (
              <article key={card.id} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-secondary-200 transition-all duration-300 cursor-pointer">
                <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                  <span className="absolute top-3 left-3 px-2 py-1 text-xs font-medium text-background-50 bg-secondary-500/90 rounded-md">
                    {card.tag}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2">{card.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}